import styles from './NotFound.module.css';

function getAppUrl(): string {
  return import.meta.env.VITE_APP_URL || window.location.origin.replace('admin.', '');
}

export function NotFound() {
  return (
    <div className={styles.container}>
      <h1 className={styles.code}>404</h1>
      <h2 className={styles.title}>Page not found</h2>
      <p className={styles.text}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <div className={styles.actions}>
        <a href="/" className={styles.link}>
          Admin Home
        </a>
        <a href={`${getAppUrl()}/dashboard`} className={styles.linkSecondary}>
          Return to Dashboard
        </a>
      </div>
    </div>
  );
}
